import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

const facebookBotTextComponentFields =
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-firstname" title="' + lang.text_html_info_firstname + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_first_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_title_first_name + '</a>' +
'</span>' + 
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-lastname" title="' + lang.text_html_info_lastname + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_last_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_title_last_name + '</a>' +
'</span>'

const instagramBotTextComponentFields =
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-lastname" title="' + lang.text_html_instagram_username_info + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_last_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_instagram_username + ' </a>' +
'</span>'

let commonFields = ! instagram_bot_addon 
  ? facebookBotTextComponentFields
  : instagramBotTextComponentFields

export const textHtml =             
'<div class="form-group text-left mt-2">' +
  '<label>' + lang.text_html_label_reply_message + '</label><br/>' +
  '<div class="text-text-custom-variable d-inline-block lead-user-name">' + 
    '<a title="' + lang.text_html_info_custom_variable + '" data-toggle="dropdown" data-toggle-second="tooltip" data-placement="top" role="button" aria-haspopup="true" aria-expanded="false" class="btn btn-link btn-sm p-0 p-1 dropdown-toggle"><i class="fa fa-cogs"></i> ' + lang.text_html_title_custom + '</a>' +
    '<div class="dropdown-menu" data-animation="fadeIn"></div>' +
  '</div>' + 
  
  commonFields +

  '<div class="clearfix"></div><textarea class="form-control text_message"  name="text-text-message" id="text-text-message"></textarea>' +
'</div>' +

// Adds html for delay system
delayHtml
